var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var VotingThumbs_1;
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { classNameWithModifier } from '@slickdeals/durango/dist/javascript/utilities/css';
import BlueprintComponent from '../core/blueprintComponent';
import './icon';
import './strong';
import DealVote from '../models/voting/dealVote';
import '../../scss/components/votingThumbs.scss';
/** The name of the module */
export const name = 'VotingThumbs';
/* This is the url to send the fetch API so that the ajax request can be made indicating a thumbs up/down by the user */
export const AJAX_URL = '/forums/sdthreadrate_ajax.php';
export const CSS_CLASSNAME = 'bp-c-votingThumbs';
/* This class includes post methods for the thumbs up and down functionality on the deal cards */
let VotingThumbs = VotingThumbs_1 = class VotingThumbs extends BlueprintComponent {
    constructor(options) {
        super(name, options);
    }
    async init() {
        super.init();
        if (typeof this.element === 'undefined') {
            this.element = await BlueprintComponent.loadElement(name, this.options);
        }
        if (this.element) {
            this.element.addEventListener('click', this.handleThumbsClick.bind(this));
            // TODO: https://jira.slickdeals.net/browse/SLICKDEALS-63963
            this.element.addEventListener('vote', this.handleVote.bind(this));
        }
    }
    async registerVote(dealVote) {
        const response = await fetch(AJAX_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: (new URLSearchParams(VotingThumbs_1.getData(dealVote))).toString(),
        });
        // TODO: https://jira.slickdeals.net/browse/SLICKDEALS-63959
        const responseData = await response.json();
        if (response.status !== 200) {
            // TODO: https://jira.slickdeals.net/browse/SLICKDEALS-63962
            const voteErrorEvent = new CustomEvent('voteError', {
                detail: responseData,
            });
            document.dispatchEvent(voteErrorEvent);
        }
        else {
            const voteEvent = new CustomEvent('vote', {
                detail: { vote: responseData.htmlbit['@attributes'].voted > 0 ? 'up' : 'down' },
            });
            this.element.dispatchEvent(voteEvent);
        }
        return response;
    }
    handleThumbsClick(event) {
        event.stopPropagation();
        event.preventDefault();
        const dealVote = new DealVote(this.getPostId(), this.getVote(event.target), this.getForumId());
        if (dealVote.getVote() === '1') {
            this.registerVote(dealVote);
        }
        else {
            // TODO: https://jira.slickdeals.net/browse/SLICKDEALS-63962
            const customEvent = new CustomEvent('showVoteWidget', {
                detail: {
                    dealVote,
                    clickTarget: event.currentTarget,
                    votingThumbs: this,
                },
            });
            document.dispatchEvent(customEvent);
        }
    }
    handleVote(event) {
        if (event.detail.vote === 'up') {
            this.element.classList.remove(classNameWithModifier(CSS_CLASSNAME, 'down'));
            this.element.classList.add(classNameWithModifier(CSS_CLASSNAME, 'up'));
        }
        else if (event.detail.vote === 'down') {
            this.element.classList.remove(classNameWithModifier(CSS_CLASSNAME, 'up'));
            this.element.classList.add(classNameWithModifier(CSS_CLASSNAME, 'down'));
        }
    }
    // TODO: https://jira.slickdeals.net/browse/SLICKDEALS-63959
    static getData(dealVote) {
        return {
            postid: dealVote.getPostId(),
            vote: dealVote.getVote(),
            votetypeid: dealVote.getVoteTypeId(),
            // TODO: https://jira.slickdeals.net/browse/SLICKDEALS-63957
            securitytoken: window.SECURITYTOKEN,
            response_type: 'json',
            controltype: 'modern',
            do: 'sdthreadratevote',
            ajax: '1',
            where_from: AJAX_URL,
        };
    }
    getForumId() {
        return this.element.dataset.forumId;
    }
    getPostId() {
        return this.element.dataset.postId;
    }
    getVote(el) {
        return el.closest(`#${this.element.id} > [data-vote]`).dataset.vote;
    }
};
VotingThumbs = VotingThumbs_1 = __decorate([
    injectable(name)
], VotingThumbs);
BlueprintComponent.instantiate(name);
export default VotingThumbs;
